export default __webpack_public_path__ + "static/mocuts-7346266959702e2b7daf54c3ce7d96aa.webp";